import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PageLoader } from './ui';

/**
 * Role-aware guard.
 * @param {string[]} roles - allowed roles. 'member' implicitly includes admins
 *                           (handled here since admins outrank members).
 */
export default function ProtectedRoute({ roles = [], children }) {
  const { isAuthenticated, role, loading } = useAuth();
  const location = useLocation();

  if (loading) return <PageLoader label="Checking your session…" />;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  const allowed =
    roles.length === 0 ||
    roles.includes(role) ||
    (roles.includes('member') && role === 'administrator');

  if (!allowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
